import "./style.css";

const AlertWarning = ({ children }) => {
    return (
        <div className="warning-info-container">
            <div className="description-element">
                {children}
            </div>
        </div>
    );
}

export default AlertWarning;
